import React from "react";
import ReactDOM from "react-dom";
import "./AlertBox.css";

export default function AlertBox({ message, onClose, success, isConfirmation = false, onConfirm }) {
  const modal = (
    <div className="alert-overlay">
      <div className="alert-modal">
        <p className={success}>{message}</p>
        <div className="alert-buttons">
          {isConfirmation ? (
            <>
              <button className="alert-modal-button confirm" onClick={onConfirm}>
                Yes
              </button>
              <button className="alert-modal-button cancel" onClick={onClose}>
                No
              </button>
            </>
          ) : (
            <button className="alert-modal-button" onClick={onClose}>
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
  return ReactDOM.createPortal(modal, document.body);
}